// extracted by mini-css-extract-plugin
export default {"box":"dragable_box__gIv8w"};